import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

const getAuthToken = () => {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Save book writing content
export const saveBookWritingContent = async (data) => {
  try {
    const response = await apiClient.post("/detectors/book-writing-save", data);
    return response.data;
  } catch (error) {
    console.error("Error saving book writing content:", error);
    throw error.response?.data || error;
  }
};

// Get book writing history
export const getBookWritingHistory = async (userId, machineId, generatorType = null) => {
  try {
    const response = await apiClient.post("/detectors/book-writing-history", {
      userId,
      machineId,
      generatorType,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching book writing history:", error);
    throw error.response?.data || error;
  }
};

// Get single saved content
export const getBookWritingById = async (id, userId, machineId) => {
  try {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (machineId) params.append("machineId", machineId);
    const response = await apiClient.get(`/detectors/book-writing/${id}?${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching saved content:", error);
    throw error.response?.data || error;
  }
};

// Update saved content
export const updateBookWritingContent = async (id, generatedContent, title) => {
  try {
    const response = await apiClient.put(`/detectors/book-writing-update/${id}`, {
      generatedContent,
      title,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating saved content:", error);
    throw error.response?.data || error;
  }
};

// Delete saved content
export const deleteBookWritingContent = async (id) => {
  try {
    const response = await apiClient.delete(`/detectors/book-writing-delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting saved content:", error);
    throw error.response?.data || error;
  }
};

// Get statistics
export const getBookWritingStats = async (userId, machineId) => {
  try {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (machineId) params.append("machineId", machineId);
    const response = await apiClient.get(`/detectors/book-writing-stats?${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching stats:", error);
    throw error.response?.data || error;
  }
};